/* eslint-disable react/prop-types */
import { AppBar, Box, Tab, Tabs, Typography } from '@mui/material';
import { Portlet } from 'components';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import TotalList from '../TotalList';
import VideoList from '../VideoList';
import PDFList from '../PDFList';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export default function List(props) {
  const { onVideoClick, videos, currentVideo, pdf } = props;
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const all = videos && pdf ? videos.length + pdf.length : 0;

  return (
    <Portlet>
      <AppBar
        color="default"
        indicatorColor="primary"
        position="static"
        textColor="primary"
        variant="fullWidth"
      >
        <Tabs
          centered
          indicatorColor="secondary"
          onChange={handleChange}
          textColor="secondary"
          value={value}
          variant="fullWidth"
        >
          <Tab label={'Todos (' + all + ')'} {...a11yProps(0)} />
          <Tab label={'Videos (' + videos.length + ')'} {...a11yProps(1)} />
          <Tab label={'Documentos (' + pdf.length + ')'} {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <TabPanel index={0} value={value}>
        <TotalList
          onVideoClick={onVideoClick}
          videos={videos}
          currentVideo={currentVideo}
          pdf={pdf}
        />
      </TabPanel>
      <TabPanel index={1} value={value}>
        <VideoList
          currentVideo={currentVideo}
          onVideoClick={onVideoClick}
          videos={videos}
        />
      </TabPanel>
      <TabPanel index={2} value={value}>
        <PDFList pdf={pdf} />
      </TabPanel>
    </Portlet>
  );
}
